import React, { useState, useEffect, useMemo } from "react";

import Autocomplete from "@material-ui/lab/Autocomplete";
import { Box, Button, Divider, TextField } from "@material-ui/core";

import { printLabel, Label } from "../../containers/LabelSelector/LabelSelector";
import { Props, LabelType, DeploymentDataType, QueryParamsType, WeightPrefixEnum } from "./_types";
import LabelCheckerTrasheventList from "./LabelCheckerTrasheventList";

const LabelCheckerTrashevents: React.FC<Props> = (props) => {
  // Filters
  const [startDate, setStartDate] = useState<string>("");
  const [endDate, setEndDate] = useState<string>("");
  const [labelSelection, setLabelSelection] = useState<Array<LabelType>>([]);
  const [weightSelection, setWeightSelection] = useState<number>(0);
  const [weightPrefixSelection, setWeightPrefixSelection] = useState<WeightPrefixEnum>(
    WeightPrefixEnum.ABOVE_OR_EQUAL_TO
  );
  const [labellerSelection, setLabellerSelection] = useState<Array<LabelType>>([]);

  const deploymentData: DeploymentDataType = useMemo(
    () => (props.history.location.state ? props.history.location.state.deploymentData : {}),
    [props.history]
  );

  const labelData: Array<LabelType> = props.history.location.state
    ? Object.values(props.history.location.state.fullLabelData).map((fl: Label & { value: string }) => ({
        id: fl.id,
        label: printLabel(fl),
        value: fl.value,
      }))
    : [];
  const labellerData: Array<LabelType> = props.history.location.state ? props.history.location.state.labellerData : [];

  const [queryParams, setQueryParams] = useState<QueryParamsType>(null);

  useEffect(() => {
    if (!props.history.location.state) props.history.push("/labelChecker");

    setStartDate(deploymentData.data_validity ? deploymentData.data_validity.split(".").reverse().join("-") : "");
    setEndDate(deploymentData.oldest_unlabelled ? deploymentData.oldest_unlabelled.split(".").reverse().join("-") : "");
  }, [props.history, deploymentData]);

  const onApply = () => {
    setQueryParams({
      deployment_id: deploymentData.id,
      weight: weightSelection,
      weight_prefix: weightPrefixSelection,
      label_ids: labelSelection.map((label) => label.id),
      labeller_ids: labellerSelection.map((labeller) => labeller.id),
      start_date: startDate,
      end_date: endDate,
    });
  };

  return (
    <div
      className="animated fadeIn"
      style={{
        display: "flex",
        flexDirection: "column",
        height: "85vh",
      }}
    >
      <h1>
        {[deploymentData.customer, deploymentData.property, deploymentData.outlet, deploymentData.area].join(
          "\u00A0\u00A0>\u00A0\u00A0"
        )}
      </h1>
      <Box
        display="flex"
        alignItems="flex-start"
        justifyContent="flex-start"
        style={{
          padding: "10px 0",
          gap: "20px",
          flexWrap: "wrap",
          marginTop: "20px",
          zIndex: 0,
        }}
      >
        <Autocomplete
          multiple
          limitTags={1}
          id="labels"
          options={labelData}
          getOptionLabel={(option) => option.label}
          value={labelSelection}
          onChange={(_, selection: LabelType[]) => setLabelSelection(selection)}
          getOptionSelected={(option, value) => option.id === value.id}
          disableCloseOnSelect
          filterSelectedOptions
          size="small"
          style={{ width: 500 }}
          renderInput={(params) => <TextField {...params} variant="outlined" label="Labels" />}
        />

        <Box style={{ display: "flex", gap: "20px" }}>
          <TextField
            key="startDate"
            type="date"
            size="small"
            variant="outlined"
            label="Start date"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
          />
          <TextField
            key="endDate"
            type="date"
            size="small"
            variant="outlined"
            label="End date"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
          />
        </Box>

        <Box display="flex" alignItems="center">
          <Autocomplete
            key="weightOptionSelect"
            onChange={(_, option: WeightPrefixEnum) => setWeightPrefixSelection(option)}
            options={Object.values(WeightPrefixEnum)}
            getOptionLabel={(option: WeightPrefixEnum) => option}
            value={weightPrefixSelection}
            getOptionSelected={(option, value) => option === value}
            disableClearable
            style={{ width: "180px" }}
            size="small"
            renderInput={(params) => <TextField {...params} variant="outlined" label="Weight" />}
          />

          <TextField
            type="number"
            size="small"
            variant="outlined"
            label="Grams"
            value={weightSelection}
            onChange={(e) => {
              const val = e.target.value;
              // if empty or negative, set to 0
              setWeightSelection(val === "" ? 0 : Math.max(0, parseInt(val) || 0));
            }}
            inputProps={{ min: 0 }}
            style={{ width: "120px" }}
          />
        </Box>

        <Autocomplete
          multiple
          limitTags={1}
          id="labellers"
          options={labellerData}
          getOptionLabel={(option) => option.label}
          value={labellerSelection}
          onChange={(_, selection: LabelType[]) => setLabellerSelection(selection)}
          getOptionSelected={(option, value) => option.id === value.id}
          disableCloseOnSelect
          filterSelectedOptions
          size="small"
          style={{ width: 400 }}
          renderInput={(params) => <TextField {...params} variant="outlined" label="Labellers" />}
        />

        <Button variant="contained" color="primary" onClick={onApply}>
          Apply
        </Button>
      </Box>

      <Divider />

      {queryParams && <LabelCheckerTrasheventList queryParams={queryParams} />}
    </div>
  );
};

export default LabelCheckerTrashevents;
